import { ReactNode } from 'react';
import { MenuItemContentWrapper, MenuTitleTextWrapper } from './Styled';

type TitleMenuItemProps = {
  /**  Identifier of the menu item */
  id: string;
  /** Component that will be displayed as the menu title if label is not provided. */
  content?: ReactNode;
  /** Text that will be displayed as the menu title if content is not provided. */
  label?: string;
};

export const TitleMenuItem = ({ id, label, content }: TitleMenuItemProps) => {
  return (
    <MenuItemContentWrapper isDisabled data-test={`title-menu-item-${id}`}>
      {label ? <MenuTitleTextWrapper>{label}</MenuTitleTextWrapper> : content}
    </MenuItemContentWrapper>
  );
};
